<template>
  <div class="bread">
    <!-- 柱状图表格 -->
    <template v-if="tableData.length>0">
      <div id="columnarChart"
           ref="columnar"
           class="columnarChart"
           :style="{width: isMobile ? '355px' : '100%', height: isMobile ? (h + 'px') : '100%'}"></div>
    </template>

    <template v-if="tableData.length === 0">
      <div class="nodata">
        <span>
          <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
          <div>暂无数据</div>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import {getFieldName} from './js/color.js';
let chartsModel = "";
// var curInt = null;


export default {
  name: 'heatMap',
  props: {
    h: Number,
    //- 分组字段数据
    row: {
      type: Array,
      default: ()=>[]
    },
    //- 汇总字段数据
    summary: {
      type: Array,
      default: ()=>[]
    },
    //- drage组件大小修改后，饼图实时更新
    changeSize: {
      type: Number,
      default: 0
    },
    //- 表格数据
    tableData: {
      type: Array,
      default: ()=>[]
    },
    //- 表id
    id: {
      type: Number,
      default: 0
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean,
      default: ()=>false
    },
    viewShow: {
      type: Boolean,
      default: ()=>false
    },
    selectIndex: {
      type: Number,
      default: ()=>null
    },
    user: {
      type: Array,
      default: () => []
    },
    width: [String, Number],
    isMobile: {
      type: Boolean,
      default: false
    },
    theme: Object,
    column: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      myChart: '',
    }
  },
  mounted() {
    console.log("this.selectIndex==>",this.selectIndex);
    // if(this.selectIndex){
    //     curInt = this.selectIndex;
    // }
    this.$nextTick(()=>{
      this.openFunBread();
    })

  },
  methods: {
    updateFun(){
      console.log("更新");
      if (this.myChart.resize) this.myChart.resize();

    },
    //- 打开图表
    openFunBread(){
      console.log("openFun",this.tableData.length);
      if(this.tableData.length <= 25 && this.tableData.length > 0){
        this.$nextTick(()=>{
          this.initData();
        })

      }

    },
    getCoordinates () {
      let x = []
      let y = []
      for (const i of this.tableData) {
        for (const s of i) {
          if (s) {
            x.push(s.name)
            for (const c of this.column) {
              const cName = getFieldName(c, 'column')
              if (s[cName]) y.push(s[cName])
            }
          }
        }
      }
      x = Array.from(new Set(x))
      y = Array.from(new Set(y))
      return {
        x: x,
        y: y
      }
    },
    getSeries ({x, y}) {
      const arr = []
      for (const i of this.tableData) {
        for (const s of i) {
          if (s) {
            const columnName = this.column[0] ? getFieldName(this.column[0], 'column') : ''
            const summaryName = this.summary[0] ? this.summary[0].name : ''
            const xIndex = x.indexOf(s.name)
            const yIndex = y.indexOf(s[columnName])
            arr.push([xIndex, yIndex, s[summaryName]])
          }
        }
      }
      return arr
    },
    //- 创建图表
    initData() {
      if (this.column.length === 0) {
        this.$emit('update:tableData', [])
        return;
      }
      const that = this;
      const info = this.getCoordinates()
      chartsModel = "";
      // that.tableData[0].selected = true;
      that.$nextTick(()=>{
        // 基于准备好的dom，初始化echarts实例
        let dom = that.$refs.columnar;
        if (!dom) return
        echarts.registerTheme('macarons', macaronsDatas.theme)
        chartsModel = echarts.init(dom,'macarons');

        let option = {
          tooltip: {
            show:true,
            trigger: 'item',
            backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              },
            }
          },
          grid:{
            top: 10,
            bottom: 20,
            left: 40,
            right: 20,
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: info.x,
            axisLabel: {
              formatter: function(value) {
                return typeof value === 'string' && value ? value.split(/\1{1}/g).join('') : value
              }
            },
            axisLine: {
              lineStyle: {
                color: "#666666"
              }
            },
          },
          yAxis: {
            type: 'category',
            data: info.y,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#6e7079'
              }
            },
          },
          visualMap: {
            min: 0,
            max: 10,
            calculable: true,
            orient: 'vertical',
            left: '0%',
            bottom: '0%',
            inRange: {
              color: ['#bf444c', '#d88273', '#f6efa6']
            }
          },
          series: [
            {
              name: '',
              type: 'heatmap',
              data: this.getSeries(info),
              label: {
                show: true
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };

        if (this.theme && this.theme.axes) {
          const axisIndex = this.theme.axes.findIndex(its => its.type === 'category')
          const axis = this.theme.axes[axisIndex]
          console.log('x轴数据', axis, axisIndex, this.theme.axes)

          option.color = this.theme.color

        }

        console.log('热力图配置', option, info)

        chartsModel.clear();
        // 绘制图表
        chartsModel.setOption(option);
        chartsModel.off("click");
        chartsModel.on("click", (param)=>{
          //- 设置柱状图点击事件
          if(that.isFrontEnd === true){
            return;
          }
          console.log("柱状图点击事件=====>",param, option);


          that.relevanceFun(param.name,param.value,param.dataIndex);
        });
        that.myChart = chartsModel;
        that.$forceUpdate();
      })
    },
    //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
    relevanceFun(name,val,index){
      console.log('点击', name, val, index)
      if(this.isFrontEnd === true){
        return;
      }
      let rowName = this.row[0].name;
      let summaryName = this.summary[0].name;
      const columnName = this.column[0].revisabilityName || this.column[0].name
      let array = {};
      const nameArr = name ? name.split(/\1{1}/g) : name;
      if (Array.isArray(nameArr)) {
        for (let i = 0; i < this.row.length; i++) {
          array[this.row[i].name] = nameArr[i]
        }
      } else {
        array[rowName] = name;
      }
      array[columnName] = val[1]
      if (this.column && this.column.length > 0) array[summaryName] = val[val.length - 1];
      let date = {
        id: this.id,
        value: array,
        selectIndex: index
      }
      if (this.user[index]) date.user = this.user[index]
      this.$emit("relevanceFun",date)
    }




  },
  watch: {
    changeSize(val) {
      console.log("w===>",val)
      if(this.tableData.length>0){
        setTimeout(() => {
          this.updateFun();

        }, 1000);

      }

    },
    'tableData':{
      handler (newV) {
        // do something, 可使用this
        console.log(newV)
        if(newV && newV.length>0){
          this.$nextTick(()=>{
            this.$forceUpdate();
            this.openFunBread();
          })
        }

      },
      deep:true

    },
    'selectIndex': {
      handler(newName) {

        console.log("变话了",newName)
        this.$nextTick(()=>{
          this.$forceUpdate();
          this.initData();
        })
      },
      deep:true
    },
    viewShow: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    width: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    theme: {
      immediate: true,
      deep: true,
      handler () {
        console.log('配置更新')
        this.initData();
      }
    },
  }
}
</script>

<style scoped lang="scss">
.bread {
  width: 100%;
  height: 100%;
  position: relative;

}
.nodata {
  width: 100%;
  text-align: center;
  color: #666666;
  //line-height: 244px;
  height: 100%;
  position: relative;
  span{
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -29px;

  }
}
</style>
